import { create } from "zustand";

type NotificationType = "success" | "error" | "info" | "warning";

interface NotificationStore {
  message: string;
  type: NotificationType;
  isVisible: boolean;
  showAlert: (message: string, type?: NotificationType) => void;
  hide: () => void;
}

export const useNotificationStore = create<NotificationStore>((set) => ({
  message: "",
  type: "info",
  isVisible: false,
  showAlert: (message, type = "info") => set({ message, type, isVisible: true }),
  hide: () => set({ isVisible: false }),
}));
